module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzEwMHB4JyB3aWR0aD0nMTAwcHgnICBmaWxsPSIjZmZmZmZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgeD0iMHB4IiB5PSIwcHgiPjxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjYiPjwvY2lyY2xlPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-dot.svg
// module id = 1031
// module chunks = 37